import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { updateDb } from "../services/updateDb";

import LoadPage from "../common/LoadPage";
import AlertMessage from "../common/AlertMessage";
import ConfirmationModal from "../common/ConfirmationModal";
import useAxiosFetch from "../common/useAxiosFetch";
import { Button } from "react-bootstrap";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../modals/ModalManager";

const ProjectPage = () => {
  const { t } = useTranslation();
  const { currentOrg, alertMessage, showAlertMessage, triggerHeaderRefresh, openModal } = useAppContext();
  const [show, setShow] = useState(false);
  const [deleteProject, setDeleteProject] = useState();
  const { data: featureLimits } = useAxiosFetch("/api/features/limits");

  const handleClose = async (deleteProject, projectId) => {
    setShow(false);

    if (deleteProject && projectId) {
      const res = await updateDb("/api/projects/" + projectId, {}, "delete");

      if (res.success) {
        triggerHeaderRefresh();
        refetch();
        showAlertMessage('error', t('domain') + " " + t('deleted'));
      }
      else {
        showAlertMessage('error', res.error ? res.error : 'Error deleting domain.');
      }
    }
  };

  const handleShow = (projectId) => {
    setDeleteProject(projectId);
    setShow(true);
  };

  const navigate = useNavigate();
  const { data, loading, refetch } = useAxiosFetch("/api/projects/byOrg/" + currentOrg.id); //forces a refresh when org is deleted

  let navigateEditProject = (orgId) => {
    navigate(`/editproject?projectId=${orgId}`);
  };

  const handleAddProject = (e) => {
    e.preventDefault();
    
    if (featureLimits) {
      const { current } = featureLimits.usage.projects;
      const maxProjects = featureLimits.limits.maxProjects;
      
      // Check if limit reached
      if (maxProjects !== -1 && current >= maxProjects) {
        openModal(MODAL_TYPES.UPGRADE, {
          featureType: 'Projects',
          currentLimit: maxProjects,
          currentCount: current,
          recommendedPlan: 'premium'
        });
        return;
      }
    }
    
    navigate('/addproject');
  };

  if (loading) 
    return <LoadPage />;

  return (
    <div id="content">
      <div id="content-title">{t('domains')}</div>

      <div className="clear-both" />

      <ConfirmationModal
        show={show}
        handleClose={handleClose}
        deleteId={deleteProject}
      />

      <Button 
        className="add-btn btn-right-top" 
        variant="primary" 
        type="button"
        onClick={handleAddProject}
      >
        +
      </Button>

      <AlertMessage type={alertMessage.type} message={alertMessage.content} />

      <div className="content-bubble content-bubble-table">
        <table className="overview-table">
          <thead>
            <tr>
              <td>{t('domain')}</td>
              <td>{t('organization')}</td>
              <td>{t('owner_without_prefix')}</td>
              <td />
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <tr key={item["id"]}>
                  <td>{item.name}</td>
                  <td>{currentOrg.name}</td>
                  <td>{item.ownerUser}</td>
                  <td>
                    <i
                      onClick={() => navigateEditProject(item["id"])}
                      className="icon-edit"
                    />
                    <i
                      onClick={() => handleShow(item["id"])}
                      className="icon-delete"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
  
};

export default ProjectPage;
